import { useStats } from 'react-instantsearch'

export default function SearchResultsStats() {
  const { nbHits, query } = useStats()

  if (nbHits <= 0) {
    return null
  }

  return (
    <div className="border-b border-grey-light py-2xl text-[18px] text-blue-oxford">
      Showing {nbHits} results for your query "{query}"
    </div>
  )
}
